import React from 'react'
import { DashboardCard } from './OutstandingBalance'
import { useTheme } from '../../../middleware/ThemeContext';
import CardIconHeader from './Components/CardIconHeader';
import StyledText from '../../../components/StyledComponents/StyledText';
import BankingFinanceIcon from '../../../assets/icons/BankingFinanceIcon';
import TooltipIcon from '../../../assets/icons/Tooltip';
import styled from 'styled-components';
import { hexToRgba } from '../../../utils/helper';
import { CardContainer } from '../../websiteBuilder/WebsiteConfiguration/SettingsComponents/CookieConsent';
import { font } from '../../../utils/themes';
import { Button } from '../../../components/form/Button';
import ArrowIcon from '../../../assets/icons/ArrowIcon';
import DotIcon from '../../../assets/icons/DotIcon';
import AlertNotice from './Components/AlertNotice';

const data = [
    {
        label: 'Membership Fee',
        amount: '$4,250.00',
    },
    {
        label: 'Directory Listing',
        amount: '$500.00',
    },
    {
        label: 'Journal Subscription',
        amount: '$200.00',
    },
    {
        label: 'Chapter Membership',
        amount: '$300.00',
    }
];

const HighestDues = () => {
    const {theme} = useTheme();
  return (
    <DashboardCard theme={theme}>
        <CardIconHeader 
            className='mb-3'
            icon={<BankingFinanceIcon size={24} color={theme.CorporateTheme.colors.ultraMarineBlue} /> }
            title='Highest Dues'
            count="$5250.00"
            iconBgColor='rgba(228, 228, 255, 0.5)'
        />
        <AlertNotice 
            message='Includes membership fee plus any recurring add‑ons (directory, journal, chapter, etc.).Expired memberships are still listed here'
        />
        <div style={{ margin: '40px 0px' }}>
            {data.map((item, index) => (
            <div key={index} className='d-flex align-items-center justify-content-between mb-3'>
                <div className='d-flex align-items-center gap-2'>
                    <DotIcon color={theme.CorporateTheme.colors.blueberry} />
                    <StyledText
                        fontSize='14px'
                        fontWeight={600}
                        textColor={theme.CorporateTheme.colors.textSecondary}
                    >
                        {item.label}
                    </StyledText>
                </div>
                <StyledText
                    fontSize='14px'
                    fontWeight={600}
                    textColor={theme.CorporateTheme.colors.redOrange}
                    fontFamily={font.lato}
                >
                    {item.amount}
                </StyledText>
            </div>
            ))}
        </div>
        <Button
            theme={theme}
            $variant='customButton'
            textColor={theme.CorporateTheme.colors.primary}
            color={theme.CorporateTheme.colors.primary}
            fontSize='12px'
            fontWeight='600'
            borderColor={theme.CorporateTheme.colors.filterBG}
            width='100%'
            textPosition='start'
        >
            View All Highest Dues
            <ArrowIcon rotate='right' color={theme.CorporateTheme.colors.gunmetal} />
        </Button>
    </DashboardCard>
  )
}

export default HighestDues